import { InvoiceResponse } from "@/api";
import React from "react";


export interface InvoiceDetailsViewProps {
  value: InvoiceResponse;
}

export default function InvoiceDetailsView({
  value,
}: InvoiceDetailsViewProps) {
  return (
    <section className="rounded-xl border bg-white p-6">
      {/* -----------------------------------------
          HEADER
      ----------------------------------------- */}


      {/* -----------------------------------------
          DETAILS
      ----------------------------------------- */}

      <div className="grid gap-6 md:grid-cols-2">
        <Detail
          label="Sales By"
          value={value.sales_by}
        />

        <Detail
          label="Supply Place"
          value={value.supply_place}
        />

        <Detail
          label="Supply State"
          value={value.supply_state}
        />

        <Detail
          label="Supply State Code"
          value={value.supply_state_code}
        />

        <Detail
          label="Requestor Vendor Code"
          value={value.requestor_vendor_code}
        />

        <Detail
          label="Requestor Vendor SPOC"
          value={value.requestor_vendor_spoc}
        />

        <Detail
          label="GST Number"
          value={value.gst_number}
        />

        <Detail
          label="PAN Number"
          value={value.pan_number}
        />
      </div>
    </section>
  );
}

/*
 * --------------------------------------------------
 * DETAIL
 * --------------------------------------------------
 */

interface DetailProps {
  label: string;
  value: unknown;
}

function Detail({
  label,
  value,
}: DetailProps) {
  return (
    <div>
      <div className="mb-1 text-sm font-medium text-gray-500">
        {label}
      </div>

      <div className="text-sm font-medium text-gray-900">
        {displayValue(value)}
      </div>
    </div>
  );
}

function displayValue(
  value: unknown,
): string {
  if (
    value === null ||
    value === undefined
  ) {
    return "—";
  }

  const text = String(value).trim();

  return text || "—";
}